import obj from './generated_components_dictionary';

const dictionary = {
    ...obj,
    //"section.name" : ImportComponent
    //e.g. : "section.hello-world" : HelloWorld
}

export default dictionary;